import * as z from 'zod';

import { BorrowerAchAccountId, BorrowerId, PortalUserId, RepayAccountId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

const DwollaAutopaySettingsInput = z.object({
  bankUrl: z.string(),
  portalUserId: PortalUserId,
  type: z.literal('dwolla'),
});

const UsioAutopaySettingsInput = z.object({
  confirmationId: z.string(),
  borrowerId: BorrowerId,
  type: z.literal('usio'),
  dayOfTheMonth: z.number().optional(),
});

const RepayAutopaySettingsInput = z.object({
  type: z.literal('repay'),
  accountId: RepayAccountId,
  borrowerId: BorrowerId,
  dayOfTheMonth: z.number(),
});

const NachaAutopaySettingsInput = z.object({
  type: z.literal('nacha'),
  accountId: BorrowerAchAccountId,
  borrowerId: BorrowerId,
  dayOfTheMonth: z.number(),
});

const AutopaySettingsInput = z.discriminatedUnion('type', [
  DwollaAutopaySettingsInput,
  UsioAutopaySettingsInput,
  RepayAutopaySettingsInput,
  NachaAutopaySettingsInput,
]);
export type AutopaySettingsInput = z.infer<typeof AutopaySettingsInput>;

export const UpdateAutopaySettingsEvent = BaseLoanEvent.extend({
  type: z.literal('updateAutopaySettings'),
  autopaySettingsInput: AutopaySettingsInput.optional(),
  isUsio: z.boolean().optional(), // disabled event needs indicator for audit log
});
export type UpdateAutopaySettingsEvent = z.infer<typeof UpdateAutopaySettingsEvent>;
